<template>
    <PasswordResetConfirm :email="this._props.email"></PasswordResetConfirm>
</template>

<script>
    import PasswordResetConfirm from "../components/PasswordResetConfirm";

    export default {
        name: "password-reset-confirm",
        props: {
            email: {
                type: String,
                default: ''
            }
        },
        components: {
            PasswordResetConfirm,
        }
    };
</script>